/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-07-25 22:09:06
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-09-15 17:56:06
 * @FilePath: /wemeet-web-activity/src/components/Image/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: manuelzhao
 * @Description: 图片统一优化
 */
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { formatUrlFoWebpNotJudge, formatUrlNotJudge } from '@utils/imageLoad';

interface OptImgProps {
  src: string;
  lazy?: boolean;
  width?: number;
  domRef?: any;
  alt?: string;
  smallToBig?: boolean;
}

const OptImage = ({ src, lazy, width, domRef, smallToBig, ...opt }: OptImgProps) => {
  const optSrc = useMemo(() => {
    if (smallToBig) {
      return formatUrlFoWebpNotJudge(src, 150);
    }

    return formatUrlFoWebpNotJudge(src, width);
  }, []);

  const [loadSrc, setLoadSrc] = useState(optSrc);

  // 加载失败时候，降级到使用刚开始的
  const onerror = useCallback(() => {
    const url = formatUrlNotJudge({
      url: src,
      domRef,
      imgWidth: width,
    });
    setLoadSrc(url);
  }, [src]);

  useEffect(() => {
    if (smallToBig) {
      const img = new Image();
      const bigSrc = formatUrlFoWebpNotJudge(src, width);
      img.src = bigSrc;
      img.onload = () => {
        setLoadSrc(bigSrc);
      };
      img.onerror = () => {
        onerror();
      };
    }
  }, [src]);

  if (!lazy) {
    return <img loading="lazy" src={loadSrc} onError={onerror} {...opt} />;
  }

  return <LazyLoadImage src={loadSrc} {...opt} onError={onerror} loading="lazy" />;
};

export default memo(OptImage);
